import { connect } from 'react-redux';
import { compose, applySpec } from 'ramda';

import { NOT_APPLICABLE } from 'constants/common';

import TransmissionReportSummary from 'components/AddTransmissionReport/TransmissionReportSummary';
import validate from 'components/AddTransmissionReport/TransmissionReportSummary/validate';

import {
  getParcingPdfLoading,
  getTransmissionReportSummaryInitialValues,
  getPatientDoctors,
  getDeviceVendor,
} from 'store/selectors/newReport';
import withPageLoader from 'components/withPageLoader';
import { withTranslation } from 'react-i18next';
import { reduxForm, formValueSelector, change } from 'redux-form';
import { FORM_NAMES } from 'constants/forms';

const selector = formValueSelector(FORM_NAMES.transmissionReportSummary);

const mapStateToProps = applySpec({
  initialValues: getTransmissionReportSummaryInitialValues,
  doctors: getPatientDoctors,
  deviceVendor: getDeviceVendor,
  alert: state => selector(state, 'alert'),
  shockNa: state => selector(state, 'shockNa'),
});

export default compose(
  withPageLoader({
    loadingSelector: getParcingPdfLoading,
  }),
  connect(
    mapStateToProps,
    dispatch => ({
      onChangeShockCheckbox: (_, newValue) =>
        dispatch(
          change(FORM_NAMES.transmissionReportSummary, 'shock', newValue ? NOT_APPLICABLE : ''),
        ),
    }),
  ),
  reduxForm({
    form: FORM_NAMES.transmissionReportSummary,
    validate,
  }),
  withTranslation(),
)(TransmissionReportSummary);
